import { useTranslation } from "react-i18next";
import { PageSEO } from "@/components/seo/PageSEO";
import { Mail } from "lucide-react";

export default function Integritetspolicy() {
  const { t } = useTranslation();

  return (
    <div>
      <PageSEO title={t("cookiePolicy.title")} description={t("seo.integritetspolicy")} />
      {/* Hero */}
      <section className="py-16 lg:py-24 bg-secondary/30">
        <div className="container mx-auto px-4 lg:px-8 text-center space-y-4">
          <h1 className="text-4xl md:text-5xl font-heading text-primary">
            {t("cookiePolicy.title")}
          </h1>
          <p className="text-muted-foreground text-sm">
            {t("cookiePolicy.lastUpdated")}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8 max-w-3xl">
          <div className="prose prose-gray max-w-none space-y-8">
            {/* Intro */}
            <p className="text-foreground/80 leading-relaxed">
              {t("cookiePolicy.intro")}
            </p>

            {/* Cookie types */}
            <div>
              <h2 className="text-xl font-heading text-primary mb-6">
                {t("cookiePolicy.purposeTitle")}
              </h2>

              <div className="space-y-6">
                {(["functional", "analytics", "thirdParty"] as const).map(
                  (key) => (
                    <div
                      key={key}
                      className="border rounded-lg p-5 bg-card"
                    >
                      <h3 className="font-semibold text-foreground mb-2">
                        {t(`cookiePolicy.types.${key}.title`)}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {t(`cookiePolicy.types.${key}.description`)}
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>

            {/* Managing cookies */}
            <div>
              <h2 className="text-xl font-heading text-primary mb-4">
                {t("cookiePolicy.managingTitle")}
              </h2>
              <p className="text-foreground/80 leading-relaxed mb-4">
                {t("cookiePolicy.managingText")}
              </p>
              <ul className="list-disc pl-6 space-y-1 text-foreground/80">
                <li>Chrome</li>
                <li>Internet Explorer</li>
                <li>Firefox</li>
                <li>Opera</li>
                <li>Safari</li>
                <li>Safari (iPhone / iPad)</li>
              </ul>
              <p className="text-foreground/80 leading-relaxed mt-4">
                {t("cookiePolicy.blockingWarning")}
              </p>
            </div>

            {/* Changes */}
            <div>
              <h2 className="text-xl font-heading text-primary mb-4">
                {t("cookiePolicy.changesTitle")}
              </h2>
              <p className="text-foreground/80 leading-relaxed">
                {t("cookiePolicy.changesText")}
              </p>
            </div>

            {/* Contact */}
            <div className="border-t pt-8">
              <h2 className="text-xl font-heading text-primary mb-4">
                {t("cookiePolicy.contactTitle")}
              </h2>
              <p className="text-foreground/80 leading-relaxed mb-3">
                {t("cookiePolicy.contactText")}
              </p>
              <a
                href="mailto:info@geposit.se"
                className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
              >
                <Mail className="h-4 w-4" />
                info@geposit.se
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
